import { useQuery } from '@tanstack/react-query';
import { planningAPI } from '../api/planning.api';
import { calculateUrgency, calculateDaysUntilRv } from '../utils/urgencyCalculator';
import { findFirstWeekWithAppointment } from '../utils/calendarHelpers';
import { PlanningExpertise } from '../types/planning.types';

export const usePlanningData = () => {
  const planningQuery = useQuery({
    queryKey: ['expert', 'planning'],
    queryFn: planningAPI.getPlanning,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const statsQuery = useQuery({
    queryKey: ['expert', 'stats'],
    queryFn: planningAPI.getStats,
    staleTime: 5 * 60 * 1000,
  });

  // Process expertise data with urgency
  const processedExpertises: PlanningExpertise[] = planningQuery.data?.data?.expertises?.map(expertise => ({
    ...expertise,
    urgency: calculateUrgency(expertise.date, expertise.date_du_rv),
    daysUntilRv: calculateDaysUntilRv(expertise.date_du_rv)
  })) || [];

  // Find the first week with appointments
  const firstWeekWithAppointment = findFirstWeekWithAppointment(processedExpertises);

  return {
    expertises: processedExpertises,
    expertName: planningQuery.data?.data?.expert || '',
    stats: statsQuery.data?.data?.stats || null,
    loading: planningQuery.isLoading || statsQuery.isLoading,
    error: planningQuery.error || statsQuery.error,
    firstWeekWithAppointment,
    refetch: () => {
      planningQuery.refetch();
      statsQuery.refetch();
    }
  };
};